<template>
	<div>
		<title-header 
			class="mb-4"
			:poll-name="poll.name"
			title="DASHBOARD"
			urlImage="/static/img/diagnosis/dashboard.svg"
		>
			<v-layout row wrap justify-end align-center>
				<area-filter
					:areas="areas"
					:area-selected="areaSelected"
					@change-area="loadData"
				></area-filter>
				<download-btn
					alt="Descargar reporte en PDF"
					:height="27"
					url-image="/static/img/icons/pdf.svg"
					@download-item="downloadReport('pdf')"
				></download-btn>
				<download-btn
					alt="Descargar reporte en Excel"
					:height="23"
					url-image="/static/img/icons/excel.webp"
					@download-item="downloadReport('xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel')"
				></download-btn>
				<v-btn
					class="btn-bar primary--text"
					:style="`color:${$appColors.primary};border:1px solid ${$appColors.primary}`"
					@click="btnGraphic"
				>
					Ver Gráficos
					<img 
						src="/static/img/diagnosis/bar.svg" 
						alt="Ver gráficos"
						class="ml-2"
					>
				</v-btn>
			</v-layout>
		</title-header>
		<div class="px-3 pb-4">
			<v-layout row wrap>
				<v-flex xs4 pb-4>
					<row-graphic 
						:border="false"
						gray
						legend-border-right
						:row="summary.graphic" 
						without-background
					/>
				</v-flex>
			</v-layout>
			<v-layout v-for="(item, index) in summary.reportData" :key="index" mb-5>
				<v-flex xs4>
					<card-tool
						:card-reverse="item.cardReverse"
						:data="item"
						:index="index"
						small
						@reverse-card="reverseCard"
					/>
				</v-flex>
				<div class="tables-container">
					<div
						v-for="(ch, indexTable) in item.entities"
						:key="indexTable"
					>
						<table-summary :data="ch" @action="viewDetail"/>
					</div>
				</div>
			</v-layout>
		</div>
		<div class="wrapper-close">
			<v-btn 
				class="btn-detail btn-action" 
				color="primary"
				@click="goToBack">Atrás</v-btn>
		</div>
		<modal 
			:dialog="dialog"
			:create="false"
			title="Cerrar"
			@close-modal="closeModal"
			@create-employee="closeModal"
			>
			<table-modal 
				:columns="columns"
				:rows="rows"
				combination
				>
					<template slot="rows" slot-scope="props">
						<td><span
							class="font-blue mr-2"
							:style="`color:${$appColors.primary}`"
						>{{ props.row.id }}.</span><span>{{ props.row.name }}</span></td>
						<td>{{ props.row.value ? props.row.value : 0 }}</td>
					</template>
			</table-modal>
		</modal>
	</div>
</template>
<script>
import areaFilter from '@/components/diagnosis/area-filter';
import cardTool from '@/components/diagnosis/card-tool';
import downloadBtn from '@/components/diagnosis/download-btn';
import helper from '@/shared/helper';
import modal from '@/components/configuration/open-modal';
import rowGraphic from '@/components/surveys/action-one/row-graphic';
import tableModal from '@/components/configuration/assign-area';
import tableSummary from '@/components/diagnosis/table-summary';
import titleHeader from '@/components/diagnosis/title-header';

const { generateBlob, showDownloadDialog } = helper;

function data() {
	return {
		areaId: 0,
		areas: [],
		areaSelected: 0,
		columns: [
			{ id: 1, name: 'Nombre', col: 1 },
			{ id: 2, name: 'Total', col: 1 },
		],
		dialog: false,
		poll: {},
		rows: [],
		summary: [],
	};
}

function created() {
	this.loadData();
}

async function downloadReport(type, contentType) {
	const body = {
		id: this.idsummary,
	};
	if (this.areaId) {
		body.areaId = this.areaId;
	}
	try {
		const { data: pdfData } = await this.$httpPraktiko.post(
			`reports/organizational-culture-inventory/${type}`, body, { responseType: 'blob' });
		const blob = generateBlob(pdfData, contentType);
		showDownloadDialog(blob, 'reporte_inventario_de_cultura_organizacional', type);
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

async function loadData(areaParam) {
	this.areaId = areaParam || null;
	const params = {};
	if (this.areaId) {
		params.areaId = this.areaId;
	}
	try {
		const { data: response } = await this.$httpPraktiko.get(
			`diagnostic-detail/${this.idsummary}/item`, { params });
		response.reportData = response.reportData.map((r) => {
			const newRow = { ...r };
			newRow.value = Math.round(r.total) || 0;
			newRow.cardReverse = false;
			return newRow;
		});
		const newArea = { code: 'GE01', id: 0, name: 'Todas' };
		response.groups.unshift(newArea);
		this.areas = response.groups.map(ac =>
			({ code: ac.code, id: ac.id, name: ac.name }));
		this.summary = response;
		this.setGraphics(response);
		this.poll = response.poll || null;
	} catch (error) {
		this.showGenericError();
	}
}

function setGraphics(res) {
	this.summary.graphic = [
		{
			image: '/static/img/diagnosis/app.svg',
			number: res.totalResolved,
			numberTotal: res.numApplicants,
			description: 'Aplicantes',
		},
		{
			image: '/static/img/diagnosis/male.svg',
			number: res.numMale,
			numberTotal: res.numTotalMale,
			description: 'Masculino',
		},
		{
			image: '/static/img/diagnosis/female.svg',
			number: res.numFemale,
			numberTotal: res.numTotalFemale,
			description: 'Femenino',
		},
	];
}

function goToBack() {
	const { toolId } = this.$route.params;
	this.goTo('detail-diagnoses', { params: { toolId, id: this.id } });
}

function closeModal(value) {
	this.dialog = value;
}

function viewDetail(item) {
	this.dialog = true;
	this.columns[0].name = item.name;
	this.columns[1].name = `TOTAL: ${item.total}`;
	this.rows = item.entities;
}

function btnGraphic() {
	this.goTo('detail-summary-graphic-inventory', { params: { toolId: this.toolId } });
}

function reverseCard(itemValue) {
	this.$set(itemValue, 'cardReverse', !itemValue.cardReverse);
}

export default {
	name: 'inv-summary',
	created,
	data,
	components: {
		areaFilter,
		downloadBtn,
		cardTool,
		modal,
		rowGraphic,
		tableModal,
		tableSummary,
		titleHeader,
	},
	methods: {
		btnGraphic,
		closeModal,
		downloadReport,
		goToBack,
		loadData,
		setGraphics,
		viewDetail,
		reverseCard,
	},
	props: {
		id: [Number, String],
		idsummary: [Number, String],
		toolId: [Number, String],
	},
};
</script>
<style lang="scss" scoped>
	.wrapper-graphic {
		margin: 0 auto 40px auto;
		width: 40%;
	}

	.wrapper-close {
		align-items: center;
		background: map-get($colors, white);
		border-top: 1px solid map-get($colors, border-gray);
		bottom: 0;
		display: flex;
		justify-content: center;
		padding: 16px 0 19px 0;
		position: fixed;
		left: 70px;
		right: 0;
	}

	.font-blue {
		font-family: map-get($fonts, bold);
	}

	.btn-bar {
		background: transparent !important;
		border-radius: 18px;
		box-shadow: none !important;
		font-family: font(regular) !important;
		font-size: 13px !important;
		margin-left: 20px; 
		text-transform: none;
	}

	.tables-container {
		display: grid;
		grid-template-columns: repeat(4, 165px);
		grid-column-gap: 15px;
		margin-left: 15px;
		overflow: auto;
	}
</style>





// WEBPACK FOOTER //
// src/pages/diagnosis/page-inv-summary.vue